import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrToolbarComponent } from './pr-toolbar.component';

@NgModule({
  imports: [CommonModule],
  exports: [PrToolbarComponent],
  declarations: [PrToolbarComponent],
})
export class PrToolbarModule {}
